module.exports = __webpack_public_path__ + "static/medka3.a14d5281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/medka-site/medka3.png
// module id = 216
// module chunks = 35783957827783 246384609461072